import React from "react";
import * as S from "./styles";

import { Categoria } from "./Categoria";

export function Categorias({
  listaDeCategorias,
  setCategoria,
  selectedCategoria,
}) {
  function handleClick(categoria) {
    if (selectedCategoria === categoria.titulo) setCategoria("all");
    else setCategoria(categoria.titulo);
  }

  return (
    <S.Container>
      <h1>Categorias</h1>
      <S.ListaCategorias>
        {listaDeCategorias?.map((categoria) => (
          <Categoria
            selected={categoria.titulo === selectedCategoria ? 1 : 0}
            onClick={() => handleClick(categoria)}
          >
            {categoria.titulo}
          </Categoria>
        ))}
        {!listaDeCategorias.length && <>Nenhuma categoria encontrada ! :(</>}
      </S.ListaCategorias>
    </S.Container>
  );
}
